import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { BannerTransition as BannerTransitionType } from './BannerTransition.tsx';

const BannerTransition = lazyAfterPaint<typeof BannerTransitionType>(
	() =>
		import(/* webpackChunkName: "async-banner-eoc-transition" */ './BannerTransition.tsx').then(
			(module) => module.BannerTransition,
		),
	{
		ssr: true,
		entryFsSsrLiftImportToModule: true,
		// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
		includeInShellOnlySsrBundle: true,
	},
);

export const BannerTransitionAsync = (): React.JSX.Element => (
	<Placeholder name="async-banner-eoc-transition" fallback={null}>
		<BannerTransition />
	</Placeholder>
);
